// Func = limiting Scope for this file
var lastScrollTop = 0;

var scrollParallaxH = [];
var lastScrollLeft = [];

var opened = 0;
var start = $('#arriveInput').attr('value');
var end = $('#departureInput').attr('value');


(function(){

	//burgerMenu
	if(document.getElementById('burgerMenu')){
		document.getElementById('burgerMenu').addEventListener('click',function(){
			if(this.classList.contains('open')){
				this.classList.remove('open');
				this.getElementsByClassName('text')[0].innerHTML = 'Menu';
				document.getElementById('header').classList.remove('menu-open');
				document.getElementById('mainNav').classList.remove('open')
			} else {
				this.classList.add('open');
				this.getElementsByClassName('text')[0].innerHTML = 'Close';
				document.getElementById('header').classList.add('menu-open');
				document.getElementById('mainNav').classList.add('open')
			}
		})
	}
	//booking Cta
	if(document.getElementById('bookingCta')){
		document.getElementById('bookingCta').addEventListener('click',function(e){
			e.preventDefault();
			if(this.classList.contains('open')){
				this.classList.remove('open');
				document.getElementById('header').classList.remove('booking-open');
				document.getElementById('bookingBlock').classList.remove('open');
				this.getElementsByTagName('span')[0].innerHTML = 'Book Now';
			} else {
				this.classList.add('open');
				document.getElementById('header').classList.add('booking-open');
				document.getElementById('bookingBlock').classList.add('open');
				this.getElementsByTagName('span')[0].innerHTML = 'Close';
			}
		})
	}

	//main menu submenus
	if(document.getElementsByClassName('submenu').length > 0){
		let allMainLinks = document.getElementById('primary-nav').getElementsByTagName('a');
		for(let i = 0; i < allMainLinks.length; i++){
			allMainLinks[i].addEventListener('click', function(e){
				if(this.nextElementSibling.classList.contains('submenu')){
					e.preventDefault();
					if(this.nextElementSibling.classList.contains('open')){
						this.nextElementSibling.classList.remove('open')
					} else {
						this.nextElementSibling.classList.add('open')
					}
				}
			})
		}
	}


	window.onload = function() {
		if(document.getElementById('home')){
			scrollW();
			window.addEventListener('scroll', function(){
				scrollW();
			})
		} else {
			document.getElementById('header').classList.add('down');
		}
		

		window.addEventListener('resize', function(){
			resizeWindow();
		})

		//*********    Intersection for parallax effect and other cool animations
		if(!(window.ActiveXObject) && "ActiveXObject" in window){
			//is explorer (-_-)
		}else {
			//parallax horizontal
			if(document.getElementsByClassName('parallax-image').length > 0){
				if(window.innerWidth > 1090 ){
					let horizontalOptions = {
						root : null,
						rootMargin : '0px',
						threshold : 0.1
					}
					function handlerParallaxH(entries, observer){
						for(let entry of entries){
							if (entry.isIntersecting) {
								parallaxEffectH(entry.target);
							} else {
								let id_elem = entry.target.getAttribute('parallax-id');
								window.addEventListener('scroll', scrollParallaxH[id_elem])
							}
						}
					}
					let allParallax = document.getElementsByClassName('parallax-image');
					for(let  j = 0; j < allParallax.length; j++ ){
						let observerP = new IntersectionObserver(handlerParallaxH, horizontalOptions)
						observerP.observe(allParallax[j]);
					}
	
				}
			}
		}

	};

	$(document).ready(function () {

		

		//To create after event 
		$.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
		$.datepicker._updateDatepicker = function (inst) {
			$.datepicker._updateDatepicker_original(inst);
			var afterShow = this._get(inst, 'afterShow');
			if (afterShow)
				afterShow.apply((inst.input ? inst.input[0] : null));  // trigger custom callback
		}
		$('#bookingCalendar').datepicker({
			changeMonth: false,
			dateFormat: 'yy-mm-dd',
			numberOfMonths: 2,
			minDate:new Date(2022, 11 - 1, 8),
			beforeShowDay: function (date) {

				$.datepicker._defaults.dateFormat = "yy-mm-dd";
				var startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				if (date.getTime() == startDate.getTime()) {
					return [true, "startday"];
				} else {
					if (date.getTime() == endDate.getTime()) {
						return [true, "endday"];
					} else {
						if (date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) {
							return [true, "days"];
						} else {
							return [true, ""];
						}
					}
				}
			},
			onSelect: function (date) {
				var arrive = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var departure = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);

				if (opened == 0) {
					opened = 1;
					start = date;
					end = date;
					
				} else {
					opened = 0;
					if (selectedDate <= arrive) {
						end = start;
						start = date;
					} else {
						end = date;
					}
				
					
				}
				$('#arriveInput').attr('value', start);
				$('#departureInput').attr('value', end);

				let SplitArrive = start.split('-');
				let SplitDeparture = end.split('-');

				$('#altDates').attr('value', (SplitArrive[1] +'-'+ SplitArrive[2]+'-'+ SplitArrive[0]) + ' / ' + (SplitDeparture[1] +'-'+ SplitDeparture[2]+'-'+ SplitDeparture[0]));
			
			},
			onChangeMonthYear: function () {
				
			}
		});


		
		
	});

	

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if(!document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.add('down');
		}
	} else {
		if(document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
function resizeWindow(){}

function parallaxEffectH(target){
	let id_elem = target.getAttribute('parallax-id');
	let temp = parseInt(target.getAttribute('data-parallax').split(',')[1]);
	let targetImage = target.getElementsByTagName('img')[0];

	let parallaxFunctionT = function(){
		
		let stp = window.pageYOffset || document.documentElement.scrollTop;

		if(lastScrollLeft[id_elem] === undefined){
			lastScrollLeft[id_elem] = parseInt(stp) - 1;
		}

		// console.log('scroll' + stp);
		// console.log('last' + lastScrollLeft[id_elem]);
		
		let direction = target.getAttribute('data-parallax').split(',')[0];
		if (stp > lastScrollLeft[id_elem]){
			
			temp = temp + (direction * 0.2);
			lastScrollLeft[id_elem] = stp - 1;
		} else {
			
			temp = temp - (direction * 0.2);
			lastScrollLeft[id_elem] = stp + 1;
		}
		//if(temp >= 0){
	
			targetImage.setAttribute('style','transform:translateY(' + parseInt(temp) + 'px)');
			target.setAttribute('data-parallax',direction + ',' + parseInt(temp) );
		//}
		
		

	}
	

	scrollParallaxH[id_elem] = parallaxFunctionT
	window.addEventListener('scroll', scrollParallaxH[id_elem])
}